import { RootState } from "@/store/store";
import { billingExplorerCsvPossibleColumnsFormatedDataSelector } from "@/store/resource-explorer/selectors/current-resource-explorer/csv/possible-columns/billingExplorerCsvPossibleColumnsFormatedDataSelector";
import { billingExplorerFilterTreeProvidersSelector } from "@/store/resource-explorer/selectors/filter-tree/billingExplorerFilterTreeProvidersSelector";
import { BillingExplorerCSVColumnItem } from "@/store/resource-explorer/selectors/current-resource-explorer/csv/possible-columns/utils/types";

export const billingExplorerCsvPossibleColumnsFilteredFormatedDataSelector = (
  state: RootState,
): BillingExplorerCSVColumnItem[] | undefined => {
  const formatedData =
    billingExplorerCsvPossibleColumnsFormatedDataSelector(state);
  const filterProviders = billingExplorerFilterTreeProvidersSelector(state);

  if (!filterProviders || !filterProviders?.length) {
    return formatedData;
  }

  return formatedData?.filter((item) => {
    return (
      item.providers.includes("global") ||
      item.providers.includes("dimensions") ||
      filterProviders.includes("dimensions") ||
      item.providers.some((prov) => filterProviders?.includes(prov))
    );
  });
};
